/** @format */

import React from 'react'
import { Result, Button } from 'antd'
import { NavLink } from 'react-router-dom'
import Images from '../Images';

import './styles.css'

export default function Error404() {
	return (
		<Result
			icon={<Images  
					default="https://storage.googleapis.com/tirx-resources-production/28d6f23b-23f7-46b8-a48d-b02525941bb5.png"
					alt="404 error image"
					classContent='error-img'
				/>}
			title='404'
			subTitle='Sorry, the page you visited does not exist.'
			extra={
				<Button type='primary'>
					<NavLink to='/'>Back Home</NavLink>
				</Button>
			}
		/>
	)
}
